export default Object.freeze({
    CREATE: "Create",
    GUEST: "Guest",
    MAIN: "Main",
    SIGNIN: "SignIn",
  });
  